import { createAction, createReducer } from '@reduxjs/toolkit';
import type {
    UpgradeSubscriptionPlanArgs,
    UpgradeSubscriptionPlanResponse,
    UpgradeSubscriptionSetArgs,
    UpgradeSubscriptionSetResponse,
} from 'reactApp/api/billing/upgradeSubscription/UpgradeSubscriptionAPICall.types';

const initialState: {
    upgradePlan: {
        isLoading: boolean;
        isLoaded: boolean;
        data: UpgradeSubscriptionPlanResponse | null;
    };
    upgradeSet: {
        isLoading: boolean;
        isLoaded: boolean;
        data: UpgradeSubscriptionSetResponse | null;
    };
} = {
    upgradePlan: {
        isLoading: false,
        isLoaded: false,
        data: null,
    },
    upgradeSet: {
        isLoading: false,
        isLoaded: false,
        data: null,
    },
};

export const upgradeSubscriptionPlanRequest = createAction<UpgradeSubscriptionPlanArgs>('upgrade/subscriptionPlanRequest');
export const upgradeSubscriptionPlanSuccess = createAction<UpgradeSubscriptionPlanResponse>('upgrade/subscriptionPlanSuccess');

export const upgradeSubscriptionSetRequest = createAction<UpgradeSubscriptionSetArgs>('upgrade/subscriptionSetRequest');
export const upgradeSubscriptionSetSuccess = createAction<UpgradeSubscriptionSetResponse>('upgrade/subscriptionSetSuccess');

export const upgradeReducer = createReducer(initialState, {
    [upgradeSubscriptionPlanRequest.type]: (state) => {
        state.upgradePlan.isLoading = true;
        state.upgradePlan.isLoaded = false;
    },
    [upgradeSubscriptionPlanSuccess.type]: (state, action) => {
        state.upgradePlan.isLoading = false;
        state.upgradePlan.isLoaded = true;
        state.upgradePlan.data = action.payload;
    },
    [upgradeSubscriptionSetRequest.type]: (state) => {
        state.upgradeSet.isLoading = true;
        state.upgradeSet.isLoaded = false;
    },
    [upgradeSubscriptionSetSuccess.type]: (state, action) => {
        state.upgradeSet.isLoading = false;
        state.upgradeSet.isLoaded = true;
        state.upgradeSet.data = action.payload;
    },
});
